import { render, staticRenderFns } from "./PartnerContentSection.vue?vue&type=template&id=462f7db6"
import script from "./PartnerContentSection.vue?vue&type=script&lang=ts"
export * from "./PartnerContentSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports